<template>
  <svg width="16" height="18" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M4.11108 1H11.5L15 4.6V14.6" stroke="#2E2E2E" stroke-width="1.2" stroke-linecap="round"
          stroke-linejoin="round"/>
    <path
        d="M1 15.8V4.60002C1 4.28176 1.1229 3.97654 1.3417 3.7515C1.5605 3.52645 1.8572 3.40002 2.1667 3.40002H9.7516C9.8753 3.40014 9.9939 3.45078 10.0813 3.54082L12.5298 6.05922C12.5733 6.10394 12.6078 6.15708 12.6313 6.21556C12.6548 6.27405 12.6668 6.33674 12.6667 6.40002V15.8C12.6667 16.1183 12.5437 16.4235 12.325 16.6486C12.1062 16.8736 11.8094 17 11.5 17H2.1667C1.8572 17 1.5605 16.8736 1.3417 16.6486C1.1229 16.4235 1 16.1183 1 15.8Z"
        stroke="#2E2E2E" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
    <path
        d="M9.5556 3.40002V6.12002C9.5556 6.24733 9.6048 6.36942 9.6923 6.45944C9.7798 6.54945 9.8985 6.60002 10.0223 6.60002H12.6667"
        stroke="#2E2E2E" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>

<script>
export default {
  name: 'PageSVG',
};
</script>
